import { renderBoolean } from 'KnmPackage/KnmHistoriesModule/common/renderBoolean';
import { renderDate } from 'KnmPackage/KnmHistoriesModule/common/renderDate';
import { IKnmHistoryField } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryField';

import { renderErknmStatus } from '../common/renderErknmStatus';

export const planHistoryFields: Record<string, IKnmHistoryField> = {
  '/created': {
    name: 'Дата создания плана',
    active: true,
    renderFunc: renderDate,
  },
  '/plan/link': {
    name: 'Добавление проверки в план',
    active: true,
  },
  '/plan/unlink': {
    name: 'Исключение проверки из плана',
    active: true,
  },
  '/erknmStatus': {
    name: 'Статус плана',
    active: true,
    renderFunc: renderErknmStatus,
  },
  '/year': {
    name: 'Год проведения',
    active: true,
  },
  '/endDate': {
    name: 'Дата окончания',
    active: true,
    renderFunc: renderDate,
  },
  '/signed': {
    name: 'Подписание плана',
    active: true,
    renderFunc: renderBoolean,
  },
  '/prosecutorOrganization/fullName': {
    name: 'Орган прокуратуры',
    active: true,
  },
  '/knoOrganization/fullName': {
    name: 'Орган контроля',
    active: true,
  },
  '/fullNameWhoConsideredPlan': {
    name: 'ФИО рассмотревшего план',
    active: true,
  },
  '/positionWhoConsideredPlan': {
    name: 'Должность рассмотревшего план',
    active: true,
  },
  '/comment': {
    name: 'Комментарий',
    active: true,
  },
  '/supervisionType/title': {
    name: 'Вид контроля',
    active: true,
  },
  '/knmPlanData/signerFullName': {
    name: 'ФИО ответственного лица',
    active: true,
  },
  '/knmPlanData/signerPosition': {
    name: 'Должность ответственного лица',
    active: true,
  },
};
